import React from "react";
import getCorsi from "../services/getCorsi";
import getChiusura from "../services/getChiusura";
import moment from "moment";
import Cookies from "universal-cookie";

export default class GridSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chiusura: [],
    };
  }

  async componentDidMount() {
    // Carica i giorni di chiusura una volta
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    if (username && token) {
      const chiusura = await getChiusura(username, token);
      this.setState({ chiusura });
    }
  }

  // Verifica se una data è in un periodo di chiusura
  isDataInChiusura(dataLezione) {
    return this.state.chiusura.some((c) => {
      const dataChiusura = moment(c.day, "DD-MM-YYYY");
      const lezioneDate = moment(dataLezione, "YYYY-MM-DD HH:mm:ss");
      return (
        lezioneDate.format("YYYY-MM-DD") === dataChiusura.format("YYYY-MM-DD")
      );
    });
  }
  renderLessonBlock(lezione) {
    const data = lezione.data;
    const idInsegnanti = lezione.id_insegnanti.split(",");
    const insegnantiSelezionati = this.props.insegnanti.filter((insegnante) =>
      idInsegnanti.includes(insegnante.id.toString())
    );
    const nomiInsegnanti = insegnantiSelezionati.map(
      (ins) => ins.nome + " " + ins.cognome
    );

    const idMaterie = lezione.id_materia.split(",");
    const materiaSelezionata = this.props.materie.filter((materia) =>
      idMaterie.includes(materia.id.toString())
    );
    const nomiMaterie = materiaSelezionata.map((materia) => materia.materia);

    // Controllo per il pagamento quota
    const pagamentoQuota =
      lezione.pagamento_quota === "1" || lezione.pagamento_quota === 1;

    // Verifica se è una scadenza (pagamento quota in periodo di chiusura)
    const isScadenzaPagamento = pagamentoQuota && this.isDataInChiusura(data);

    function formatLezioneDate(dataStr) {
      return moment(dataStr, "YYYY-MM-DD HH.mm").format(
        "DD-MM-YYYY [ore] HH:mm"
      );
    }

    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: isScadenzaPagamento ? "#ffe6e6" : "#ddeeff", // Rosa solo per scadenze
          padding: "4px",
          boxSizing: "border-box",
          cursor: "pointer",
          border: isScadenzaPagamento ? "2px solid #a00308" : "1px solid #ccc", // Bordo rosso solo per scadenze
        }}
        onClick={() =>
          this.props.onMouseClick(moment(data).format("YYYY-MM-DD"), "")
        }
      >
        <p
          style={{
            fontWeight: "bold",
            fontSize: "12px",
            margin: 0,
            color: isScadenzaPagamento ? "#a00308" : "#333", // Testo rosso solo per scadenze
          }}
        >
          {formatLezioneDate(data)}
        </p>

        {isScadenzaPagamento ? (
          // Visualizzazione per scadenza pagamento (pagamento quota in chiusura)
          <div>
            <p
              style={{
                fontSize: "12px",
                margin: "2px 0",
                color: "#a00308",
                fontWeight: "bold",
              }}
            >
              💰 SCADENZA PAGAMENTO
            </p>
            <p
              style={{
                fontSize: "10px",
                margin: "2px 0",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              (Non è una lezione)
            </p>
          </div>
        ) : (
          // Visualizzazione per lezione normale (anche con pagamento quota)
          <div>
            <p style={{ fontSize: "12px", margin: 0, color: "#333" }}>
              {nomiInsegnanti.join(", ")}
            </p>
            {nomiMaterie.length > 0 ? (
              <p style={{ fontSize: "10px", margin: "2px 0 0", color: "#555" }}>
                {nomiMaterie.join(", ")}
              </p>
            ) : (
              <p style={{ fontSize: "10px", margin: "2px 0 0", color: "#555" }}>
                Lezione
              </p>
            )}
            {pagamentoQuota && (
              <p
                style={{
                  fontSize: "10px",
                  margin: "2px 0 0",
                  color: "#ffffff",
                  fontWeight: "bold",
                  backgroundColor: "#a00308",
                  padding: "1px 3px",
                  borderRadius: "3px",
                  display: "inline-block",
                }}
              >
                $ Pagamento
              </p>
            )}
          </div>
        )}
      </div>
    );
  }

  renderGrid() {
    const currentYear = moment().year();
    const mesi = Array.from({ length: 12 }, (_, i) =>
      moment(`${currentYear}-${i + 1}`, "YYYY-M").format("YYYY-MM")
    );

    const lezioniPerMese = {};
    (this.props.lezioni || []).forEach((lezione) => {
      const mese = moment(lezione.data).format("YYYY-MM");
      if (!lezioniPerMese[mese]) {
        lezioniPerMese[mese] = [];
      }
      lezioniPerMese[mese].push(lezione);
    });

    let rows = mesi.map((mese, index) => {
      const lezioniDelMese = lezioniPerMese[mese] || [];

      const lezioniDelMeseSorted = lezioniDelMese.sort((a, b) =>
        moment(a.data, "YYYY-MM-DD HH.mm").diff(
          moment(b.data, "YYYY-MM-DD HH.mm")
        )
      );

      let cells = [];
      for (let j = 0; j < 6; j++) {
        if (j < lezioniDelMeseSorted.length) {
          const lezione = lezioniDelMeseSorted[j];
          const cellContent = this.renderLessonBlock(lezione);
          cells.push(
            <div
              key={j}
              style={{
                flex: 1,
                minWidth: 150,
                minHeight: 100,
                border: "1px solid #aaa",
                boxSizing: "border-box",
              }}
            >
              {cellContent}
            </div>
          );
        } else {
          cells.push(
            <div
              key={j}
              style={{
                flex: 1,
                minWidth: 150,
                minHeight: 100,
                border: "1px solid #aaa",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
              onClick={() => this.props.onMouseClick(mese, "")}
            />
          );
        }
      }

      return (
        <div key={index} style={{ marginBottom: "10px" }}>
          <div
            style={{
              textAlign: "left",
              fontWeight: "bold",
              fontSize: "14px",
              marginBottom: "4px",
            }}
          >
            {moment(mese, "YYYY-MM").format("MMMM")}
          </div>
          <div style={{ display: "flex" }}>{cells}</div>
        </div>
      );
    });

    return rows;
  }

  render() {
    return (
      <div
        style={{
          width: "100%",
          maxWidth: 1400,
          margin: "0 auto",
          position: "relative",
        }}
      >
        {this.renderGrid()}
      </div>
    );
  }
}
